import {
  SearchReleaseNoteOutput,
  SearchReleaseNoteQuery,
} from 'switch-shared/modules/crud/release-note/release-note.dto';

import { baseAPI } from './baseAPI.service';
import { API_METHODS } from './config/apiTags';

export const releaseNoteApi = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    searchReleaseNotes: builder.query<
      SearchReleaseNoteOutput,
      SearchReleaseNoteQuery
    >({
      query: (params) => ({
        url: 'release-note',
        method: API_METHODS.GET,
        params,
      }),
    }),
  }),
});

export const { useSearchReleaseNotesQuery } = releaseNoteApi;
export default releaseNoteApi;
